<template>
  <lu-vbox class='app-container svpad-in-20' lu-flex>
    <Spinner ref='spinner' />

    <lu-hbox>
      <PageHeader :title='headTitle' :hasList='true' :hasReload='true' :hasPrev='hasPrev' :hasNext='hasNext' @prev='goPrev' @next='goNext' @back='back' @reload='reload' >
        <lu-hbox slot='extraArea' class='pad-in-5' >
          <template v-if='isEdit'>
            <lu-item><el-button class="button" icon="el-icon-check"  @click.stop='saveAdmin'>{{ $t('action.save') }}</el-button></lu-item>
            <lu-item><el-button class="button" icon="el-icon-close"  @click.stop='cancelAdmin'>{{ $t('action.cancel') }}</el-button></lu-item>
          </template>
          <template v-if='!isReadOnly'>
            <lu-item><el-button class="button" icon="el-icon-check"  @click.stop='save'>{{ $t('action.save') }}</el-button></lu-item>
            <lu-item><el-button class="button" icon="el-icon-close"  @click.stop='cancel'>{{ $t('action.cancel') }}</el-button></lu-item>
          </template>
          <template v-else-if='$acl.isAllowed("adminRoleEdit")'>
            <lu-item><el-button class="button" icon="el-icon-edit" @click.stop='edit' >{{ $t('action.edit') }}</el-button></lu-item>
            <lu-item><el-button class="button" icon="el-icon-delete" v-if='form.isUsed === 0' @click.stop='handleDelete([{roleId: form.roleId}])' >{{ $t('action.delete') }}</el-button></lu-item>
          </template>
        </lu-hbox>
       </PageHeader>
    </lu-hbox>

    <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'>
    <lu-vbox lu-flex >
      <el-form ref='form' :model='form' lu-flex label-width="200px" :rules="dynamicRules">
          <lu-hbox class='sectionBox' lu-vcenter lu-flex-wrap style='margin-top: 10px'>
            <el-form-item label="Role Name" prop="label">
              <el-input v-model='form.label' :disabled='isReadOnly' :readonly='isReadOnly'/>
            </el-form-item>
            <el-form-item label="Status" prop="status" >
              <el-switch v-model='form.status' :disabled='isReadOnly || form.isUsed !== 0' :readonly='isReadOnly'
                :active-value='1'
                :inactive-value='0'
                :active-text="$t('active')"
                :inactive-text="$t('Inactive')"
              />
            </el-form-item>
          </lu-hbox>
      </el-form>

      <lu-hbox class='sectionBox' lu-vcenter lu-flex-wrap>
        <PermissionTree class='subSection permTree' ref='permTree' :tree='permissionTree' :maxNodeId='nodeId'
          :fontClass='resizeFont("title2", "divTitle")'
          :isEdit='isEdit' :readonly='isReadOnly' style='padding: 0px 5px;'/>
      </lu-hbox>
<!--
      <lu-hbox class='sectionBox' lu-vcenter lu-flex-wrap>
        <lu-vbox class='subSection permTree' style='padding: 0px 5px;'>

          <PageTitle :title='$t("Broker Environments")' @togglePageTitle='togglePageTitle' />

          <lu-hbox lu-flex-wrap lu-flex class='pad-in-20' style='margin: 20px;'>
            <lu-hbox class='menu-tree-row el-tree el-tree-node__content' v-if="env.status === 1" v-for="env in ssbrokerListAcl" :label="env.label" :key="env.functionId">
              <lu-item     :style='{ cursor: isReadOnly ? "not-allowed" : "pointer" }' @click='toggleEnv(env)' style='margin-left: 5px; min-width: 100px;' class='menu-tree-node-label'>{{ env.label }}</lu-item>
              <el-checkbox class='menu-tree-node-content' :disabled='isReadOnly' :readonly='isReadOnly' v-model="env.isAllowed"/>
            </lu-hbox>
          </lu-hbox>
        </lu-vbox>
      </lu-hbox>
-->

      <lu-hbox class='sectionBox' lu-vcenter lu-flex-wrap>
        <BrokerTree class='subSection permTree' ref='brokerTree' :tree='brokerListAcl'
          :fontClass='resizeFont("title2", "divTitle")'
          :readonly='isReadOnly' style='padding: 0px 5px;'/>
      </lu-hbox>

  </lu-vbox>

</lu-scroll-area>
  </lu-vbox>
</template>

<script>
import FormController from '@/controllers/FormController'
import { LuVbox, LuHbox, LuItem, LuScrollArea } from 'lusis-ui'
import PageHeader from '@/components/PageHeader'
import PermissionTree from './components/permissionTree'
import BrokerTree from './components/brokerTree'
// import PageTitle from '@/components/PageTitle'
import Spinner from '@/components/Spinner'
import { mapGetters } from 'vuex'
import utilsMixin from '@/mixins/utils'
import roleMixin from './mixin'
import Debouncer from '@/utils/debounce.js'


export default {
  name: 'adminRoleEdit',
  extends: FormController,
  mixins: [ utilsMixin, roleMixin ],
  components: { LuVbox, LuHbox, LuItem, LuScrollArea, PageHeader, PermissionTree, Spinner, BrokerTree },
  created: function () {
  },
  watch: {
  },
  methods: {
    pageControllerName: function () {
      return 'adminRoleEdit'
    },
    togglePageTitle: function () {

    },
    toggleEnv: function (env) {
      if (!this.isReadOnly) {
        env.isAllowed = !env.isAllowed
      }
    },
    paramControllerName: function () {
      return 'adminRoleEdit'
    },
    getDefaultOrder: function () {
      return 'label ASC'
    },
    saveAdmin: function () {
      this.form.permissionList.functionList = this.buildPermissionList()
      this.form.permissionList.brokerList = this.buildBrokerList()
      this.isEdit = false
    },
    cancel () {
      if (this.$route.params.create) {
        this.returnPage()
      }
      else {
        this.isReadOnly = true
      }
      this.reload()
    },
    cancelAdmin () {
      this.isEdit = false
      this.reload()
    },
    edit: function () {
      this.isReadOnly = false
    },
    editAdmin: function () {
      this.isEdit = true
    },
    back: function () {
      this.returnPage()
    },
    getRecord: function () {
      this.isReadOnly = true
      return this.fetchRecord('readUserRole', {
        indDetail: 1,
        conditions: [ { 'field name': 'roleId', operator: '=', value: [ this.$route.params.recordId ] } ]
      }, 'roleList')
    },
    buildPermissionListRec: function (arr, level) {
      for (let i = 0; i < level.length; i++) {
        arr.push({
          functionId: level[i].functionId,
          isAllowed: level[i].isAllowed ? 1 : 0
        })
        this.buildPermissionListRec(arr, level[i].children)
        this.buildPermissionListRec(arr, level[i].leaves)
      }
    },
    buildPermissionList: function () {
      let arr = []
      this.buildPermissionListRec(arr, this.$refs.permTree.getModel())
      return arr
    },
    buildBrokerList: function () {
      let arr = []
      for (let i = 0; i < this.$refs.brokerTree.getModel().length; i++) {
        for (let j = 0; j < this.$refs.brokerTree.getModel()[i].brokerList.length; j++) {
          arr.push({
            functionId: this.$refs.brokerTree.getModel()[i].brokerList[j].functionId,
            isAllowed: this.$refs.brokerTree.getModel()[i].brokerList[j].isAllowed ? 1 : 0
          })
        }
      }

      return arr
    },
    buildBrokerList2: function () {
      return this.brokerList.map(l => {
        return {
          functionId: l.functionId,
          isAllowed: l.isAllowed ? 1 : 0
        }
      })
    },
    removeLeaves: function (tree, parent) {
      for (let i = 0; i < tree.length; i++) {
        if (tree[i].children.length) {
          this.removeLeaves(tree[i].children, tree[i])
          for (let j = 0; j < tree[i].leaves.length; j++) {
            let idx = tree[i].children.indexOf(tree[i].leaves[j])
            if (idx !== -1 && tree[i].leaves[j].isMenu !== 1) {
              tree[i].children.splice(idx, 1)
            }
          }
        }
        else if (parent) {
          let idx = parent.children.indexOf(tree[i])
          if (idx !== -1 && tree[i].isMenu !== 1) {
            parent.leaves.push(tree[i])
          }
        }
      }
    },
    checkLevel: function (functId) {
      if (functId === 1) {
        return 0
      }
      else {
        let isMenu = (functId - (functId % 1000)) / 1000
        let isSubMenu = (functId - (functId % 100)) / 100 - (isMenu * 10)
        let isElem = functId - ((isMenu * 1000) + (isSubMenu * 100))
        if (isSubMenu === 0) {
          return 0
        }
        else if (isElem === 0) {
          return 1
        }
        else {
          return 2
        }
      }
    },
    buildTree: function (data, perm) {
      let tree = []
      let hash = {}
      for (let i = 0; i < data.length; i++) {
        let node = {
          id: this.nodeId++,
          functionId: data[i].functionId,
          label: data[i].label,
          description: data[i].description,
          path: data[i].path,
          isMenu: data[i].isMenu,
          status: data[i].status,
          isAllowed: data[i].functionId === 1 ? true : (perm.length > 0 && typeof perm[i] !== 'undefined') ? perm[i].isAllowed !== 0 : false,
          originChildren: [],
          children: [],
          leaves: [],
          parent: null,
          parentId: data[i].parentFunctionId,
          level: this.checkLevel(data[i].functionId),
          new: false
        }
        this.checkLevel(node.functionId)
        hash[node.functionId] = node
        if (data[i].parentFunctionId) {
          let parent = hash[data[i].parentFunctionId]
          if (parent) {
            parent.children.push(node)
            node.parent = parent
          }
          parent.originChildren = [].concat(parent.children)
        }
        else {
          tree.push(node)
        }
      }
      this.removeLeaves(tree, null)
      return tree
    },
    createFormData: function () {
      this.initFormField(this.form, 'roleId', null)
      this.initFormField(this.form, 'label', '')
      this.initFormField(this.form, 'status', 1)
      this.initFormField(this.form, 'isUsed', 0)

      // this.initFormField(this.form, 'permissionList', [])
      if (this.record.permissionList) {
        this.allowedFunctions = this.record.permissionList.functionList || []
        this.allowedBrokers = this.record.permissionList.brokerList || []
      }
      else {
        this.allowedFunctions = []
        this.allowedBrokers = []
      }
    }
  },
  /*
  asyncComputed: {
    aclPermissions: {
      lazy: true,
      get: function () {
        return this.$tango.searchPermission().then(rep => {
          return {
            functionList: rep.permissionList.functionList.map(r => r),
            brokerList: rep.permissionList.brokerList.map(r => r)
          }
        }).catch(err => console.log(err))
      },
      default: {
        functionList: [],
        brokerList: []
      }
    }
  },
  */
  computed: {
    ...mapGetters([ 'isAdmin', 'userInfos', 'brokerList', 'functionList' ]),
    dynamicRules: function () {
      return this.isReadOnly ? {} : this.rules
    },
    /*
    allowedFunctions: function () {
      return this.$route.params.create ? [] : this.record.permissionList ? (this.record.permissionList.functionList || []) : []
    },
    allowedBrokers: function () {
      return this.$route.params.create ? [] : this.record.permissionList ? (this.record.permissionList.brokerList || []) : []
    },
    */
    permissionTree: function () {
      let tree = this.buildTree(this.functionList, this.allowedFunctions)
      return tree
    },
    brokerListAcl: function () {
      return this.brokerList.map(b => {
        return {
          brokerId: b.brokerId,
          brokerName: b.brokerName,
          brokerStatus: b.brokerStatus,
          brokerList: b.brokerList.map(e => {
            let idx = this.allowedBrokers.findIndex(env => env.functionId === e.functionId)
            let isAllowed = idx === -1 ? false : this.allowedBrokers[idx].isAllowed ? true : false
            return {
              functionId: e.functionId,
              label: e.label,
              status: e.status,
              isAllowed: isAllowed
            }
          })
        }
      })
    },
    headTitle: function () {
      let title = this.$t('Create') + ' ' + this.name
      if (!this.$route.params.create) {
        title = ((this.isReadOnly) ? this.name : this.$t('Edit')) + ' : '
        title += this.form.label
      }
      return title
    },
    isCollapsedOrNot: function () {
      return this.isReadOnly
    },
    param: function () {
      return this.$route.params
    },
    requiredMessage: function () {
      return this.isReadOnly ? null : this.$t('This field is required')
    },
    recordLabel: function () {
      return this.form.label
    }
  },
  data () {
    return {
      debouncer: new Debouncer(),
      isReadOnly: (!this.$route.params.create) ? this.$route.params.isReadOnly : false,
      expanded: {},
      nodeId: 0,
      name: this.$t('Role'),
      form: {
        roleId: null,
        label: null,
        status: 1,
        isUsed: null,
        permissionList: {}
      },
      allowedFunctions: [],
      allowedBrokers: [],
      rules: {
        label: [
          { required: true, message: this.$t('Please input label'), trigger: ['blur', 'change'] },
          { min: 3, message: this.$t('Minimum length should be at least 3 characters.'), trigger: ['blur', 'change'] },
          { validator: this.checkRoleName }
        ]
      }
    }
  }
}
</script>

<style scoped>

</style>
